import { NavigateOptions, useNavigate } from "react-router-dom";
import useIsInappWebview from "./useIsInappWebview";
import { sendMessage } from "utils/webview";

type UnifiedNavigateOptions = {
  replace?: boolean;
  state?: NavigateOptions["state"];
  type?: "modal" | "card" | "transparentModal";
  gestureEnabled?: boolean;
  animation?: "none" | "default" | "slide_from_right" | "slide_from_bottom";
};

export default function useUnifiedNavigate() {
  const routerNavigate = useNavigate();
  const isInappWebview = useIsInappWebview();

  function unifiedNavigate(path: string, options: UnifiedNavigateOptions = {}) {
    const { replace, type, state, gestureEnabled, animation } = options;

    if (isInappWebview) {
      const url = `${window.location.origin}${path}`;

      sendMessage(
        JSON.stringify({
          event: "open_screen",
          params: {
            url: url,
            type: type || "card",
            gestureEnabled: gestureEnabled,
            animation: animation,
            replace: replace,
          },
        })
      );

      return;
    } else {
      routerNavigate(path, { replace: replace, state: state });
      return;
    }
  }

  return unifiedNavigate;
}
